import React from 'react';

const ICON_SRC = '/brand/gridprofile-icon.png';

export const LogoMark = ({ className = 'h-9 w-auto' }) => (
  <img src={ICON_SRC} alt="GridProfile" className={className} draggable={false} />
);

/**
 * Logo oficial GridProfile (paleta 2026).
 *  - variant: 'full' | 'icon'
 *  - theme:   'dark' (sobre fundos escuros) | 'light' (sobre fundos claros)
 */
const Logo = ({
  variant = 'full',
  theme = 'dark',
  showTagline = false,
  className = '',
  iconClassName = 'h-9 w-auto',
  wordClassName = 'text-xl',
}) => {
  if (variant === 'icon') {
    return <LogoMark className={iconClassName} />;
  }

  const gridColor = theme === 'dark' ? 'text-white' : 'text-slate-900';
  const taglineColor = theme === 'dark' ? 'text-white/50' : 'text-slate-400';

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark className={iconClassName} />
      <div className="leading-none">
        <span className={`font-extrabold tracking-tight ${wordClassName} ${gridColor}`}>
          Grid<span className="brand-text-gradient">Profile</span>
        </span>
        {showTagline && (
          <p className={`mt-1 text-[9px] font-semibold tracking-[0.18em] ${taglineColor}`}>
            INTELIGÊNCIA PARA GESTÃO DE PESSOAS
          </p>
        )}
      </div>
    </div>
  );
};

export default Logo;
